export default {
  updateDcGateWayUrl(url){
    var dcgatewayJson = localStorage.getItem("dcgateway");
    var dcgateway = null

    if (dcgatewayJson != null) {
      dcgateway = JSON.parse(dcgatewayJson);
      dcgateway.url = url
    } else {
      dcgateway = {
        url: url
      }
    }

    localStorage.setItem("dcgateway", JSON.stringify(dcgateway));
  },

  doLogout(){
    localStorage.isLogin = "false";
    let LoginOption = JSON.parse(localStorage.LoginOption || "{}");
    LoginOption.password = "";
    // 退出时清空点餐的本地缓存
    let dcGateway = JSON.parse(localStorage.dcgateway || "{}");
    let ip = dcGateway.ip
    let port = dcGateway.port
    let newDcObj = {
      ip: ip,
      port: port
    }
    localStorage.setItem('dcgateway', JSON.stringify(newDcObj)) // 退出时清空点餐的本地缓存

    localStorage.LoginOption = JSON.stringify(LoginOption);
  },
}



// WEBPACK FOOTER //
// ./src/conf/userStorage.js